export const DEFAULT_QUESTIONS = [
  { text: 'Who helps the company achieve its goals more?' },
  { text: 'Who would be more difficult to replace?' },
  { text: 'Whose absence would have a bigger organizational impact?' },
  { text: 'Who contributes more often to success directly or indirectly?' }
];
